module.exports = __webpack_public_path__ + "static/media/logo-l.fd5d4ba9.svg";